module.exports = new __parcel__URL__("spellscatter.a1ec5dde.png").toString();